import Vue from 'vue';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { basic_data_table_cell_style, basic_data_table_header_style } from './constant';
import { publicApi } from '../utils/api';

//"선택"한 보고서에 대한 내용을 읽어오기
//리포트 콘텐츠(Disclosures)가 변경되는 경우 여기를 업데이트 해야 함

const report_contents = {
  namespaced: true,
  state: {
    report_contents: [
      {
        // "index": 0,
        // "report_code": "r11",
        // "gri_code": "404-1",
        // "type": "Economic",
        // "topic_id": "404",
        // "topic_name": "Economyyy",
        // "topic_name_e": "",
        // "topic_description": "",
        // "indicator_name": "ikhyun_indicator2",
        // "indicator_name_e": "ikhyun_indicator_ee",
        // "indicator_description": "what a good system",
        // "indicator_descirption_e": "what aa good system ee",
        // "indicator_requirement": "",
        // "indicator_requirement_e": "",
        // "indicator_recommends": "waht aaa good system",
        // "indicator_recommends_e": "what aaaa gooood system eee",
        // "indicator_guidance": "what aaaaa goooooood system",
        // "indicator_guidance_e": "what aaaaaa gooooooooood system eeeeee",
        // "disclosure_id": 2,
        // "direct_report": "I made a save ",
        // "direct_report_ea": "",
        // "direct_report_em" : "",
        // "time_stamp": "2020-08-13 17:02:14",
        // "data_tables": [0, 1, 2], //table_id
        // "documents": [0, 1, 2], //document_id
        // "business_cases": [0,1, 2], //business_case_id
      },
    ],
    series_100: [
      {
        name: '조직 프로필',
        name_e: 'Organizational profile',
        codes: [
          '102-1',
          '102-2',
          '102-3',
          '102-4',
          '102-5',
          '102-6',
          '102-7',
          '102-8',
          '102-9',
          '102-10',
          '102-11',
          '102-12',
          '102-13',
        ],
      },
      {
        name: '전략',
        name_e: 'Strategy',
        codes: ['102-14', '102-15'],
      },
      {
        name: '윤리 및 청렴성',
        name_e: 'Ethics and integrity',
        codes: ['102-16', '102-17'],
      },
      {
        name: '지배구조',
        name_e: 'Governance',
        codes: [
          '102-18',
          '102-19',
          '102-20',
          '102-21',
          '102-22',
          '102-23',
          '102-24',
          '102-25',
          '102-26',
          '102-27',
          '102-28',
          '102-29',
          '102-30',
          '102-31',
          '102-32',
          '102-33',
          '102-34',
          '102-35',
          '102-36',
          '102-37',
          '102-38',
          '102-39',
        ],
      },
      {
        name: '이해관계자 참여',
        name_e: 'Stakeholder engagement',
        codes: ['102-40', '102-41', '102-42', '102-43', '102-44'],
      },
      {
        name: '보고 관행',
        name_e: 'Reporting practice',
        codes: [
          '102-45',
          '102-46',
          '102-47',
          '102-48',
          '102-49',
          '102-50',
          '102-51',
          '102-52',
          '102-53',
          '102-54',
          '102-55',
          '102-56',
        ],
      },
    ],
    report_contents_loaded: false,
    report_translated_status: false,
    attach_loaded: false,
    sasb_contents: [],
    tcfd_contents: [],
    theme_option: null,
  },
  mutations: {
    update_theme_info(state, theme_option) {
      state.theme_option = JSON.parse(JSON.stringify(theme_option));
    },
    update_sb_theme_info(state, sb_theme_option) {
      state.theme_option['sb_theme_info'] = sb_theme_option;
    },
    update_sasb_contents(state, new_sasb_contents) {
      state.sasb_contents = new_sasb_contents;
    },
    update_tcfd_contents(state, new_tcfd_contents) {
      state.tcfd_contents = new_tcfd_contents;
    },
    update_report_contents(state, new_report_contents) {
      state.report_contents = new_report_contents;
    },
    update_disclosure(state, new_disclosure_obj) {
      //1. new_disclosures의 gri_code와 report_code를 기준으로 업데이트 대상을 찾음.
      let temp_report_contents = [...state.report_contents];
      let idx = temp_report_contents.findIndex(
        (item) =>
          item.report_code == new_disclosure_obj.report_code &&
          item.gri_code == new_disclosure_obj.gri_code
      );
      if (idx > -1) {
        temp_report_contents[idx].disclosure_id = new_disclosure_obj.disclosure_id;
        temp_report_contents[idx].direct_report = new_disclosure_obj.direct_report;
        temp_report_contents[idx].time_stamp = new_disclosure_obj.time_stamp;
      }
      //2. state변경 인식시킴
      state.report_contents = temp_report_contents;
    },
    update_disclosure_nan(state, new_disclosure_obj) {
      //1. new_disclosures의 gri_code와 report_code를 기준으로 업데이트 대상을 찾음.
      let temp_report_contents = [...state.report_contents];
      let idx = temp_report_contents.findIndex(
        (item) =>
          item.report_code == new_disclosure_obj.report_code &&
          item.gri_code == new_disclosure_obj.gri_code
      );
      if (idx > -1) {
        temp_report_contents[idx].nan_category = new_disclosure_obj.nan_category;
        temp_report_contents[idx].nan_reason_contents = new_disclosure_obj.nan_reason_contents;
      }
      //2. state변경 인식시킴
      state.report_contents = temp_report_contents;
    },
    add_or_update_disclosure(state, new_disclosure_obj) {
      let temp_report_contents = [...state.report_contents];
      let idx = temp_report_contents.findIndex(
        (item) =>
          item.report_code == new_disclosure_obj.report_code &&
          item.gri_code == new_disclosure_obj.gri_code
      );
      if (idx > -1) {
        temp_report_contents[idx].disclosure_id = new_disclosure_obj.disclosure_id;
        temp_report_contents[idx].direct_report_em = new_disclosure_obj.direct_report_em;
        temp_report_contents[idx].time_stamp_e = new_disclosure_obj.time_stamp_e;
      }
      state.report_contents = temp_report_contents;
    },
    update_direct_report_ea(state, new_obj) {
      if (!new_obj) return; 
      let temp_report_contents = [...state.report_contents];
      let idx = temp_report_contents.findIndex(
        (item) => item.report_code == new_obj.report_code && item.gri_code == new_obj.gri_code
      );
      if (idx > -1) {
        temp_report_contents[idx].direct_report_ea = new_obj.direct_report_ea;
        temp_report_contents[idx].direct_report_em = new_obj.direct_report_em;
      }
    },
    update_direct_report_nan_e(state, new_obj) {
      let temp_report_contents = [...state.report_contents];
      let idx = temp_report_contents.findIndex(
        (item) => item.report_code == new_obj.report_code && item.gri_code == new_obj.gri_code
      );
      if (idx > -1) {
        temp_report_contents[idx].nan_reason_contents_ea = new_obj.nan_reason_contents_ea;
        temp_report_contents[idx].nan_reason_contents_em = new_obj.nan_reason_contents_em;
      }
    },
    update_chart_relation(state, chart_id_by_gri_code) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (chart_id_by_gri_code.hasOwnProperty(disclosure.gri_code)) {
          disclosure.charts = chart_id_by_gri_code[disclosure.gri_code];
        }
      });
      state.report_contents = temp_report_contents;
    },
    
    update_data_table_relation(state, table_ids_by_gri_code) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (table_ids_by_gri_code.hasOwnProperty(disclosure.gri_code)) {
          disclosure.data_tables = table_ids_by_gri_code[disclosure.gri_code];
        }
      });
      state.report_contents = temp_report_contents;
    },
    update_document_relation(state, document_ids_by_gri_code) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (document_ids_by_gri_code.hasOwnProperty(disclosure.gri_code)) {
          disclosure.documents = document_ids_by_gri_code[disclosure.gri_code];
        }
      });
      state.report_contents = temp_report_contents;
    },
    update_business_case_relation(state, business_case_ids_by_gri_code) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (business_case_ids_by_gri_code.hasOwnProperty(disclosure.gri_code)) {
          disclosure.business_cases = business_case_ids_by_gri_code[disclosure.gri_code];
        }
      });
      state.report_contents = temp_report_contents;
    },
    update_delete_data_table(state, deleted_table_id) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
      if (Array.isArray(disclosure.data_tables)) {
        let idx = disclosure.data_tables.indexOf(deleted_table_id);
        if (idx > -1) {
          disclosure.data_tables.splice(idx, 1);
        }
      }
      });
      state.report_contents = temp_report_contents;
    },

    update_delete_chart(state, chart_id) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (Array.isArray(disclosure.charts)) {
          let idx = disclosure.charts.indexOf(chart_id);
          if (idx > -1) {
            disclosure.charts.splice(idx, 1);
          }
        }
      });
      state.report_contents = temp_report_contents;
    },
    update_delete_business_case(state, deleted_business_case_id) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
      if (Array.isArray(disclosure.business_cases)) {
        let idx = disclosure.business_cases.indexOf(deleted_business_case_id);
        if (idx > -1) {
          disclosure.business_cases.splice(idx, 1);
        }
      }
      });
      state.report_contents = temp_report_contents;
    },
    update_delete_document(state, deleted_document_id) {
      let temp_report_contents = [...state.report_contents];
      temp_report_contents.forEach((disclosure) => {
        if (Array.isArray(disclosure.documents)) {
          let idx = disclosure.documents.indexOf(deleted_document_id);
          if (idx > -1) {
            disclosure.documents.splice(idx, 1);
          }
        }
      });
      state.report_contents = temp_report_contents;
    },
    update_report_contents_loaded(state, flag) {
      state.report_contents_loaded = flag;
    },
    update_translated_status(state, flag) {
      state.report_translated_status = flag;
    },
    attach_tables_and_documents(state, { disclosure_id, data_tables, documents, business_cases }) {
      let temp_report_contents = [...state.report_contents];

      let idx = temp_report_contents.findIndex((item) => item.disclosure_id == disclosure_id);
      if (idx > -1) {
        temp_report_contents[idx].data_tables = data_tables;
        temp_report_contents[idx].documents = documents;
        temp_report_contents[idx].business_cases = business_cases;
      }
      state.report_contents = temp_report_contents;
    },
    update_attach_loaded(state, flag) {
      state.attach_loaded = flag;
    },
  },
  getters: {
    data_table_header_style(state) {
      if (state.theme_option?.theme_info?.table_header_style){
        return state.theme_option?.theme_info.table_header_style
      } else {
        return basic_data_table_header_style
      }
      
    },
    data_table_cell_style(state) {
      if (state.theme_option?.theme_info?.table_cell_style){
        return state.theme_option?.theme_info.table_cell_style
      } else {
        return basic_data_table_cell_style
      }
      
    },
    gri_100_all_contents(state) {
      let temp_100 = state.report_contents.filter((x) => x.topic_id >= 100 && x.topic_id <= 199);
      temp_100.sort((a, b) => parseFloat(a.topic_id) - parseFloat(b.topic_id));
      for (let i = 0; i < temp_100.length; i++) {
        let temp_content = { ...temp_100[i] };
        if (temp_100[i].direct_report_em != '' && temp_100[i].direct_report_em != null) {
          temp_content['direct_report_e'] = temp_100[i].direct_report_em;
        } else temp_content['direct_report_e'] = temp_100[i].direct_report_ea;

        temp_100[i] = temp_content;
      }
      return temp_100;
    },
    gri_2_all_contents(state) {
      let temp_2 = state.report_contents.filter((x) => x.topic_id == 2);
      return temp_2;
    },
    gri_2_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_2_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },

    gri_3_all_contents(state) {
      let temp_3 = state.report_contents.filter((x) => x.topic_id == 3);
      return temp_3;
    },
    gri_3_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_3_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },


    gri_100_2021_all_contents(state) {
      let temp_100 = state.report_contents.filter((x) => x.topic_id >= 101 && x.topic_id <= 199);
      return temp_100.sort((a, b) => parseFloat(a.topic_id) - parseFloat(b.topic_id));
    },
    gri_100_2021_all_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_100_2021_all_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },

    gri_200_all_contents(state) {
      let temp_200 = state.report_contents.filter((x) => x.topic_id >= 200 && x.topic_id <= 299);
      return temp_200.sort((a, b) => parseFloat(a.topic_id) - parseFloat(b.topic_id));
    },

    gri_200_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_200_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },


    gri_300_all_contents(state) {
      let temp_300 = state.report_contents.filter((x) => x.topic_id >= 300 && x.topic_id <= 399);
      return temp_300.sort((a, b) => parseFloat(a.topic_id) - parseFloat(b.topic_id));
    },
    gri_300_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_300_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },

    gri_400_all_contents(state) {
      let temp_400 = state.report_contents.filter((x) => x.topic_id >= 400 && x.topic_id <= 499);
      return temp_400.sort((a, b) => parseFloat(a.topic_id) - parseFloat(b.topic_id));
    },

    gri_400_topics(state, getters) {
      const topicsMap = new Map();

      getters.gri_400_all_contents.forEach(({ topic_id, topic_name, topic_name_e }) => {
        if (!topicsMap.has(topic_id)) {
          topicsMap.set(topic_id, { topic_id, topic_name, topic_name_e });
        }
      });

      return Array.from(topicsMap.values());
    },


    hashed_gri_200(state) {
      let temp_200_contents = [
        ...state.report_contents.filter((x) => x.topic_id >= 200 && x.topic_id <= 299),
      ];
      let temp_obj = {};
      for (let i = 0; i < temp_200_contents.length; i++) {
        let topic_id = temp_200_contents[i].topic_id;
        let temp_list = temp_200_contents.filter((x) => x.topic_id == topic_id);
        temp_list.forEach((item) => {
          if (item.direct_report_em != '' && item.direct_report_em != null) {
            item['direct_report_e'] = item.direct_report_em;
          } else item['direct_report_e'] = item.direct_report_ea;
        });

        temp_obj[topic_id] = temp_list;
      }
      return temp_obj;
    },
    hashed_gri_300(state) {
      let temp_300_contents = [
        ...state.report_contents.filter((x) => x.topic_id >= 300 && x.topic_id <= 399),
      ];
      let temp_obj = {};
      for (let i = 0; i < temp_300_contents.length; i++) {
        let topic_id = temp_300_contents[i].topic_id;
        let temp_list = temp_300_contents.filter((x) => x.topic_id == topic_id);
        temp_list.forEach((item) => {
          if (item.direct_report_em != '' && item.direct_report_em != null) {
            item['direct_report_e'] = item.direct_report_em;
          } else item['direct_report_e'] = item.direct_report_ea;
        });

        temp_obj[topic_id] = temp_list;
      }
      return temp_obj;
    },
    hashed_gri_400(state) {
      let temp_400_contents = [
        ...state.report_contents.filter((x) => x.topic_id >= 400 && x.topic_id <= 499),
      ];
      let temp_obj = {};
      for (let i = 0; i < temp_400_contents.length; i++) {
        let topic_id = temp_400_contents[i].topic_id;
        let temp_list = temp_400_contents.filter((x) => x.topic_id == topic_id);
        temp_list.forEach((item) => {
          if (item.direct_report_em != '' && item.direct_report_em != null) {
            item['direct_report_e'] = item.direct_report_em;
          } else item['direct_report_e'] = item.direct_report_ea;
        });

        temp_obj[topic_id] = temp_list;
      }
      return temp_obj;
    },
    writing_progress() {
      return 0;
      // let written_contents = []
      // let temp_contents = [...state.report_contents]
      // if(temp_contents.length>1){
      //     written_contents = temp_contents.filter(a =>
      //         (a.direct_report!=''&&a.direct_report!=null&&a.direct_report!=undefined) ||
      //         (a.data_tables.length > 0 || a.documents.length > 0 || a.business_cases.length > 0)
      //     )
      //     return written_contents.length / temp_contents.length *100
      // }else return 0
    },
  },
  actions: {
    async get_theme_info({ commit, rootState }, { report_code }) {
      try {
        const response = await publicApi.get('/custom_theme/get_theme_info?report_code=' + report_code);

        if (response.data.code) {
          commit('update_theme_info', response.data);
        } else {
          console.log(response.data.msg);
        }
      } catch (error) {
        error.message = '[테마 정보 불러오기]' + error.message;
        Sentry.captureException(error);
      }
    },
    readReportContents({ commit, dispatch, rootState }, { report_code, editor_mode }) {
      const path = rootState.backend_host + '/read_report_contents';

      return axios
        .get(path, {
          params: {
            report_code: report_code,
            editor_mode: editor_mode,
          },
        })
        .then((response) => {
          if (response.data?.code === false) {
            window.alert('잘못된 접근입니다.');
            window.history.go(-1);
            return;
          } else {
            commit('update_report_contents', response.data);
            commit('update_report_contents_loaded', true);

            dispatch('newAttachTablesAndDocuments', { report_code: report_code });
          }
        })
        .catch((error) => {
          error.message = '[보고서 내용 불러오기]' + error.message;
          Sentry.captureException(error);
        });
    },
    newAttachTablesAndDocuments({ commit, rootState }, { report_code }) {
      const path = rootState.backend_host + '/new_attach_tables_and_documents';

      return axios
        .get(path, {
          params: {
            report_code: report_code,
          },
        })
        .then((response) => {
          //repsponse.data는 [ { report_code, gri_code, attachment_id, type } ] 으로 이뤄진 배열임
          //프론트엔드에서 후처리를 통해 각 disclosure별로 id를 붙이는 작업을 해야함
          //1) data_table을 해시형태로 정리 table_ids_by_gri_code = { gri_code: [ data_table_ids ] }

          let attachData = response.data;
          if (!Array.isArray(attachData)) {
            attachData = Object.values(attachData);
          }

          let data_tables = attachData.filter((x) => x.type == 'data_table');
          let table_ids_by_gri_code = {};
          data_tables.forEach((item) => {
            if (table_ids_by_gri_code.hasOwnProperty(item.gri_code)) {
              table_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            } else {
              table_ids_by_gri_code[item.gri_code] = [];
              table_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            }
          });

          let documents = attachData.filter((x) => x.type == 'document');
          let document_ids_by_gri_code = {};
          documents.forEach((item) => {
            if (document_ids_by_gri_code.hasOwnProperty(item.gri_code)) {
              document_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            } else {
              document_ids_by_gri_code[item.gri_code] = [];
              document_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            }
          });

          let business_cases = attachData.filter((x) => x.type == 'business_case');
          let business_case_ids_by_gri_code = {};
          business_cases.forEach((item) => {
            if (business_case_ids_by_gri_code.hasOwnProperty(item.gri_code)) {
              business_case_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            } else {
              business_case_ids_by_gri_code[item.gri_code] = [];
              business_case_ids_by_gri_code[item.gri_code].push(item.attachment_id);
            }
          });

          commit('update_data_table_relation', table_ids_by_gri_code);
          commit('update_document_relation', document_ids_by_gri_code);
          commit('update_business_case_relation', business_case_ids_by_gri_code);

          commit('update_attach_loaded', true);
        })
        .catch((error) => {
          Sentry.captureException(error);
          commit('update_attach_loaded', false);
        });
    },
    saveDisclosure({ commit, rootState }, { report_code, gri_code, direct_report, type = 'GRI' }) {
      const path = rootState.backend_host + '/save_disclosure';

      let formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('gri_code', gri_code);
      formData.append('direct_report', direct_report);
      formData.append('type', type);

      return axios
        .post(path, formData)
        .then((response) => {
          let new_disclosure_obj = {
            disclosure_id: response.data.disclosure_id,
            report_code: response.data.report_code,
            gri_code: response.data.gri_code,
            direct_report: response.data.direct_report,
            time_stamp: response.data.time_stamp,
          };
          commit('update_disclosure', new_disclosure_obj);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            alert(`다시 로그인해 주십시오.`);
            this.$store
              .dispatch('logout', null, { root: true });
          } else {
            alert(`저장 오류가 발생하였습니다. 작성하실 보고서를 다시 선택해 주세요`);
            window.location.href = rootState.frontend_host;
          }
          error.message = '[Disclosure 저장]' + error.message;
          Sentry.captureException(error);
        });
    },
    async saveNaNDisclosure(
      { commit, rootState },
      { report_code, gri_code, nan_category, nan_reason_contents }
    ) {
      try {
        const path = rootState.backend_host + '/update_disclosure_nan';

        const response = await axios.post(path, {
          rc: report_code,
          gri_code: gri_code,
          nan_category: nan_category,
          nan_reason_contents: nan_reason_contents,
        });

        if (response.data.code) {
          let new_disclosure_obj = {
            disclosure_id: response.data.disclosure_id,
            report_code: response.data.report_code,
            gri_code: response.data.gri_code,
            nan_category: response.data.nan_category,
            nan_reason_contents: response.data.nan_reason_contents,
          };
          commit('update_disclosure_nan', new_disclosure_obj);
        }
        return response;
      } catch (error) {
        if (error.response.status == 401) {
          alert(`다시 로그인해 주십시오.`);
          this.$store
            .dispatch('logout', null, { root: true });
        } else {
          alert(`저장 오류가 발생하였습니다. 작성하실 보고서를 다시 선택해 주세요`);
          window.location.href = rootState.frontend_host;
        }
        error.message = '[보고생략 저장]' + error.message;
        Sentry.captureException(error);
      }
    },

    async saveTranslatedNaNDisclosure(
      { commit, rootState },
      { report_code, disclosure_id, nan_reason_contents_em, re_initiate }
    ) {
      try {
        const response = await axios.post(rootState.backend_host + '/save_omission_em', {
          disclosure_id: disclosure_id,
          nan_reason_contents_em: nan_reason_contents_em,
          re_initiate: re_initiate,
        });

        if (response.data.code) {
          let new_disclosure_obj = {
            report_code: report_code,
            disclosure_id: disclosure_id,
            nan_reason_contents_em: nan_reason_contents_em,
          };
          commit('update_direct_report_nan_e', new_disclosure_obj);
        }
        return response;
      } catch (error) {
        if (error.response.status == 401) {
          alert(`다시 로그인해 주십시오.`);
          this.$store
            .dispatch('logout', null, { root: true });
        } else {
          alert(`저장 오류가 발생하였습니다. 작성하실 보고서를 다시 선택해 주세요`);
          window.location.href = rootState.frontend_host;
        }
        error.message = '[보고생략 번역 저장]' + error.message;
        Sentry.captureException(error);
      }
    },
    translateReport({ rootState, dispatch }, { report_code, specific_indicator = '' }) {
      const path = rootState.backend_host + '/translate_report';
      let formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('specific_indicator', specific_indicator);

      return axios
        .post(path, formData)
        .then(() => {
          Vue.prototype.$EventBus.$emit(
            'make-toast',
            '번역 완료',
            '전체 보고서 번역이 완료되었습니다.'
          );
        })
        .catch((error) => {
          dispatch('updateTranslateStatus',{ report_code: report_code, translate_status: 'error' });
          alert(`번역 오류가 발생하였습니다. 다시 시도해 주세요.`);
          window.location.href = rootState.frontend_host;
          error.message = '[보고서 번역이슈]' + error.message;
          Sentry.captureException(error);
        });
    },

    saveDisclosureE(
      { commit, rootState },
      { report_code, gri_code, direct_report_em, type = 'GRI' }
    ) {
      // 개별 gri_code 별 direct report em 직접저장
      const path = rootState.backend_host + '/save_disclosure_em';

      let formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('gri_code', gri_code);
      formData.append('direct_report_em', direct_report_em);
      formData.append('type', type);
      return axios.post(path, formData).then((response) => {
        let new_disclosure_obj = {
          disclosure_id: response.data.disclosure_id,
          report_code: response.data.report_code,
          gri_code: response.data.gri_code,
          direct_report_ea: response.data.direct_report_ea,
          direct_report_em: response.data.direct_report_em,
          ime_stamp: response.data.time_stamp,
          time_stamp_e: response.data.time_stamp_e,
        };
        commit('add_or_update_disclosure', new_disclosure_obj);
      });
    },
    async checkReportTranslated({ commit, rootState }, report_code) {
      try {
        const path = rootState.backend_host + '/translate/status';
        const response = await axios.get(path, {
          params: {
            report_code: report_code,
          }
        })
        if (response) {
          commit('update_translated_status', response.data.translate_status_info);
        }
      } catch (error) {
        error.message = '[보고서 번역상태]' + error.message;
        Sentry.captureException(error);
      }
    },
    async updateTranslateStatus({ commit, rootState }, {report_code, translate_status}) {
      try {
        const path = rootState.backend_host + '/translate/status/' + report_code;
        const response = await axios.put(path, {
          translate_status: translate_status
        })
        if (response) {
          commit('update_translated_status', response.data.translate_status_info);
        }
      } catch (error) {
        error.message = '[보고서 번역상태]' + error.message;
        Sentry.captureException(error);
      }
    },
    reInitiateDisclosure({ commit, rootState }, { disclosure_id, re_initiate, type = 'GRI' }) {
      const path = rootState.backend_host + '/translate_disclosure';

      let formData = new FormData();
      formData.append('disclosure_id', disclosure_id);
      formData.append('type', type);
      if (re_initiate != null && re_initiate != undefined)
        formData.append('re_initiate', re_initiate); //re_initiate 를 true로 보내면, direct_report_em을 삭제함
      return axios.post(path, formData).then((response) => {
        commit('update_direct_report_ea', response.data);
      })
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
    },
    async reInitiateNaNDisclosure(
      { commit, rootState },
      { disclosure_id, nan_reason_contents_em, re_initiate }
    ) {
      const response = await axios.post(rootState.backend_host + '/translate_omission_disclosure', {
        disclosure_id: disclosure_id,
        nan_reason_contents_em: nan_reason_contents_em,
        re_initiate: re_initiate,
      });

      commit('update_direct_report_nan_e', response.data);
    },

    async fetchSelectedTcfd({ commit, rootState }, report_code) {
      const response = await axios.get(
        `${rootState.backend_host}/tcfd/read_tcfd_all_indicators_list_sort_by_category_for_viewer?rc=${report_code}`
      );

      commit('update_tcfd_contents', response.data.result);
    },

    async translateSbReport({ commit, dispatch, rootState }, { report_code, specific_indicator = '' }) {
      const path = rootState.backend_host + '/storyboard/translate_sb_report';
      let formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('specific_indicator', specific_indicator);

    try {
        const response = await axios.post(path, formData);
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '번역 완료',
          '전체 보고서 번역이 완료되었습니다.'
        );
        return response;
      } catch (error) {
        dispatch('updateTranslateStatus', { report_code, translate_status: 'error' });
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '번역 오류',
          '번역 오류가 발생하였습니다. 다시 시도해 주세요.'
        );
        error.message = '[웹보고서 번역]' + error.message;
        Sentry.captureException(error);
        window.location.href = rootState.frontend_host;
        throw error;
      }
    },

    async fetchSelectedSasb({ commit, rootState }, report_code) {
      try {
        const response = await axios.get(
          `${rootState.backend_host}/sasb/get_indicator_disclosures_list_for_viewer?rc=${report_code}`
        );

        if (response.data.code) {
          commit(
            'update_sasb_contents',
            JSON.parse(response.data.result, (key, value) => {
              // 2024-06-12: 백(파이썬)에서는 dictonary의 key 순서를 보장하나, js에서 그게 안돼서 다음과 같이 수정함
              if (typeof value === 'object' && value !== null) {
                if (!Array.isArray(value)) {
                  // 객체가 배열이 아닌 경우 원래 순서를 유지
                  return Object.keys(value).reduce((acc, k) => {
                    acc[k] = value[k];
                    return acc;
                  }, {});
                } else {
                  // 객체가 배열인 경우 각 요소를 처리
                  return value.map((item) => {
                    if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
                      return Object.keys(item).reduce((acc, k) => {
                        acc[k] = item[k];
                        return acc;
                      }, {});
                    }
                    return item;
                  });
                }
              }
              return value;
            })
          );
        }
      } catch (error) {
        window.alert(error);
        error.message = '[SASB 불러오기]' + error.message;
        Sentry.captureException(error);
      }
    },
  },
};

export default report_contents;
